module.exports = __webpack_public_path__ + "static/media/card_bg_3.56bc5699.png";